import { TXTCLI_Password_may_not_start_with_th_ELL } from '../translations';
import type { Error } from '../types';

export const checkUserPassword = (value: string): Error => {
  const invalid = value?.startsWith('tmp');

  return {
    valid: !invalid,
    message: invalid ? TXTCLI_Password_may_not_start_with_th_ELL : undefined
  };
};
